import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';

export const useLogClickHome = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_HOME',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
      },
    });
  }, [logGoodsAnalytics]);
};
